import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, giroId) {
        state.id = giroId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_GIRO'(state, giro) {
        state.nombre = giro.nombre.toUpperCase().trim();
        state.inactivo = giro.inactivo;
        state.rowVersion = giro.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, giroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', giroId);

            if (giroId != 0) {
                apiAxios.get('giros-empresas/' + giroId + '/abm' ) 
                .then(res => {
                    commit('SET_GIRO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let giro = {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }

            let url = 'giros-empresas';
            if (state.id != 0) {
                url += '/' + state.id;
                giro.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, giro)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}